import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { pushToDataLayer } from '../helpers';
import { IN_VIEW, ON_SUCCESS } from '../constants';
const GTMEvent = ({
  dataLayerObject,
  eventTrigger,
  currentLocation,
  handleOnSuccess
}) => {
  const [shouldPushLayer, setShouldPushLayer] = useState(false);
  const isViewEvent = eventTrigger === IN_VIEW;
  const isOnSuccess = eventTrigger === ON_SUCCESS && !!handleOnSuccess;
  useEffect(() => {
    setShouldPushLayer(true);
  }, [currentLocation]);
  const pushDataLayer = () => {
    pushToDataLayer(dataLayerObject);
    setShouldPushLayer(false);
    if (isOnSuccess) handleOnSuccess();
  };
  if (!isViewEvent && shouldPushLayer) pushDataLayer();
  return /*#__PURE__*/React.createElement(React.Fragment, null, isViewEvent && shouldPushLayer && /*#__PURE__*/React.createElement(Waypoint, {
    onEnter: pushDataLayer
  }));
};
GTMEvent.propTypes = {
  handleOnSuccess: PropTypes.func.isRequired,
  dataLayerObject: PropTypes.object.isRequired,
  eventTrigger: PropTypes.string.isRequired,
  currentLocation: PropTypes.string.isRequired
};
export default GTMEvent;
//# sourceMappingURL=GTMEvent.js.map